import { graphql } from "gql";

const INTERNAL_ADMIN_TAGS_SET_ACTIVE_MUTATION = graphql(`
  mutation InternalAdminTagsSetActive(
    $organizationId: ID!
    $idList: [ID!]!
    $active: Boolean!
  ) {
    internalAdminTagsSetActive(
      organizationId: $organizationId
      idList: $idList
      active: $active
    ) {
      ...Tag
    }
  }
`);

export default INTERNAL_ADMIN_TAGS_SET_ACTIVE_MUTATION;
